import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import classes from './classes.module.scss';
import { paymentSourcesTheme } from '../../config/const';
import AddApplePayOption from '../../payment_options/apple_pay/add_apple_pay_option';
import { PurchaseSvgIcon } from '../../sprites';
import { applePayIsSupported, getAddIconNameForPOWVersion, googlePayIsSupported } from '../../purchase_details_common/purchase_details_common_utils';

const sideManuTitle = ({ existing, t }) => {
  if (existing && existing.length < 1) return t('purchase.add_a_new_payment_method');
  return t('purchase.add_another_payment_method');
};

const addSourceImgId = ({ kind }) => {
  if (kind === 'pp') {
    return getAddIconNameForPOWVersion('add_pp');
  }
  if (kind === 'iap') {
    return getAddIconNameForPOWVersion('add_iap');
  }
  if (kind === 'ap') {
    return 'add_ap';
  }
  if (kind === 'gp') {
    return 'add_gp';
  }
  return getAddIconNameForPOWVersion('add_cc');
};

const getAddButtonText = ({
  theme, existing, kind, t
}) => {
  if (theme === paymentSourcesTheme.wallet) return sideManuTitle({ existing, t });
  return t(`purchase.add_${ kind }`);
};

const getAddButtonClasses = (loading, kind) => {
  if (loading) return classnames(classes.addButton, classes.skeleton);
  if (kind === 'pp') {
    return classnames(classes.addButton, classes.addPPButton);
  }
  if (kind === 'gp') {
    return classnames(classes.addButton, classes.addGPButton);
  }
  return classes.addButton;
};

const getAddButtonId = ({ kind }) => {
  if (kind === 'iap') return 'in_app_purchase';
  if (kind === 'cc') return 'add_new_cc';
  if (kind === 'ap') return 'add_new_ap';
  if (kind === 'gp') return 'add_new_gp';
  return 'continue_with_paypal';
};

function AddPaymentMethod({
  kind,
  addSource,
  theme = paymentSourcesTheme.wallet,
  existing = [],
  loading,
  trackPaymentMethodClickedEvent,
  context,
  analyticsEvents
}) {
  const { t } = useTranslation();

  const onAdd = () => {
    if (trackPaymentMethodClickedEvent) trackPaymentMethodClickedEvent(kind);
    if (addSource) addSource(kind);
  };

  const renderAddAPPaymentMethod = () => {
    if (!applePayIsSupported()) return null;
    return <AddApplePayOption topPadding={ 15 } kind={ kind } context={ context } analyticsEvents={ analyticsEvents } loading={ loading } />;
  };

  const renderAddPaymentMethod = () => {
    if (kind === 'gp' && !googlePayIsSupported()) return null;
    return (
      <div className={ classes.container }>
        <button
          id={ getAddButtonId({ kind }) }
          type="button"
          onClick={ onAdd }
          className={ getAddButtonClasses(loading, kind) }
        >
          <PurchaseSvgIcon
            id={ addSourceImgId({ kind }) }
            className={ kind === 'gp' ? classes.addButtonImgGP : classes.addButtonImg }
          />
          <div className={ classes.popupAddButtonText }>
            { getAddButtonText({
              theme, existing, kind, t
            }) }
          </div>
        </button>
      </div>
    );
  };

  return kind === 'ap' || kind === 'am' ? renderAddAPPaymentMethod() : renderAddPaymentMethod();
}

export default AddPaymentMethod;
